require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-172-material-lead-times.json") })
        }
      }, "path---article-172-material-lead-times");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-172-material-lead-times!./.cache/json/article-172-material-lead-times.json
// module id = 521
// module chunks = 231608221292675